var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { attrs: { hidden: _vm.hidden } }, [
    _c("div", { staticClass: "menu grid" }, [
      _c("div", { staticClass: "span-4" }, [
        _c("span", [_vm._v("Language:")]),
        _vm._v(" "),
        _c(
          "a",
          {
            style: "es" === _vm.locale ? "color: #409EFF" : "",
            on: {
              click: function ($event) {
                return _vm.updateLocale("es")
              },
            },
          },
          [
            _c("span", [
              _vm.locale === "es"
                ? _c("i", { staticClass: "el-icon-check" })
                : _vm._e(),
              _vm._v(" ES\n        "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("|")]),
        _vm._v(" "),
        _c(
          "a",
          {
            style: "en" === _vm.locale ? "color: #409EFF" : "text-default",
            on: {
              click: function ($event) {
                return _vm.updateLocale("en")
              },
            },
          },
          [
            _c("span", [
              _vm.locale === "en"
                ? _c("i", { staticClass: "el-icon-check" })
                : _vm._e(),
              _vm._v(" EN\n        "),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "span-4" }, [
        _vm._v("\n      Admin Version: "),
        _c("b", [_vm._v(_vm._s(_vm.vars.COMMIT))]),
        _vm._v(
          "\n      - " +
            _vm._s(_vm._f("capitalize")(_vm.vars.NODE_ENV)) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      !_vm.isHomePage && !_vm.isProfilePage
        ? _c(
            "div",
            { staticClass: "span-4", staticStyle: { display: "inline-flex" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "fit-content", "margin-right": "10px" },
                  attrs: {
                    filterable: "",
                    placeholder: "Select timezone",
                    size: "small",
                  },
                  on: { change: _vm.updateTimezone },
                  model: {
                    value: _vm.selectedLocation,
                    callback: function ($$v) {
                      _vm.selectedLocation = $$v
                    },
                    expression: "selectedLocation",
                  },
                },
                _vm._l(_vm.timezones, function (group) {
                  return _c(
                    "el-option-group",
                    { key: group.label, attrs: { label: group.label } },
                    _vm._l(group.options, function (timezone, index) {
                      return _c(
                        "el-option",
                        { key: index, attrs: { value: timezone.label } },
                        [
                          _c("span", [
                            _c("i", { staticClass: "el-icon-location" }),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(timezone.label) +
                                " (" +
                                _vm._s(timezone.tz) +
                                ") "
                            ),
                          ]),
                        ]
                      )
                    }),
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "el-input el-input--small",
                  staticStyle: { width: "fit-content", "font-size": "13px" },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.currentLocation.tz) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "info",
                      attrs: {
                        content:
                          "The customer's timezone is selected by default",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }